import {Button, TextInput} from "omoplay";
import React, {useRef, useState} from "react";
import {fileUpload} from "../api/file/file.api";
import SuspensePopup from "./SuspensePopup";
import {generateBenefitImage} from "../api/ai/ai.api";


const ImageForm = ({imageUrl, onChangeImageUrl, sizeInfo, sizeLimit, showAIButton, benefitName}) => {
    const fileInputRef = useRef(null)
    const [showAIPopup, setShowAIPopup] = useState(false)
    const [disabledBtn, setDisabledBtn] = useState(false)

    const uploadImage = (e) => {
        const file = e.target.files[0]
        if (!file) return;

        if (sizeLimit) {
            const img = new Image();
            const objectUrl = URL.createObjectURL(file);

            img.onload = () => {
                const {width, height} = img;

                if (width > sizeLimit.width || height > sizeLimit.height) {
                    alert(`이미지 해상도는 ${sizeLimit.width}x${sizeLimit.height}px 이하만 허용됩니다.`);
                    URL.revokeObjectURL(objectUrl);
                    return;
                }
                URL.revokeObjectURL(objectUrl);

                fileUpload(file).then(({data}) => {
                    onChangeImageUrl(data)
                    e.target.value = null
                })
            };

            img.onerror = () => {
                alert("이미지 파일을 불러올 수 없습니다.");
                URL.revokeObjectURL(objectUrl);
            }

            img.src = objectUrl
        } else {
            fileUpload(file).then(({data}) => {
                onChangeImageUrl(data)
                e.target.value = null
            })
        }
    }

    const handleButtonClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    }

    return (
        <>
            <div>
                <div className="flex gap-2">
                    <input
                        accept="image/png, image/jpeg"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        type="file"
                        onChange={(e) => uploadImage(e)}
                    />
                    <div className="flex-1">
                        <TextInput
                            readOnly
                            placeholder="이미지 파일을 업로드 해주세요."
                            value={imageUrl}
                        />
                    </div>
                    <Button
                        variants="dark"
                        value="첨부"
                        onClick={handleButtonClick}
                        style={{ width: "85px", height: "40px" }}
                    />
                    {
                        showAIButton && (<Button variants="ai" value="AI 생성" style={{ width: "85px", height: "40px"}} onClick={() => setShowAIPopup(true)} />)
                    }
                </div>
                <p className="text-gray-400 text-xs mt-2">
                    { sizeInfo ? sizeInfo +  ' / ' : '' }지원파일 : JPG, PNG (최대 10MB)
                </p>
            </div>
            <SuspensePopup title="AI 이미지 생성" visible={showAIPopup}
                           onClose={() => setShowAIPopup(false)}
                           confirmText={<div className="flex">이미지 생성</div>}
                           confirmDisabled={disabledBtn}
                           onConfirm={() => {
                               setDisabledBtn(true)
                               generateBenefitImage(benefitName, "").then(({data}) => {
                                   if (!data.includes("https")) {
                                       alert(data)
                                   } else {
                                       onChangeImageUrl(data)
                                   }
                                   setDisabledBtn(false)
                                   setShowAIPopup(false)
                               }).catch((e) => {
                                   // AI 생성 실패(503) — 사유 alert 후 버튼 복구. 종전엔 500 → /notfound 튕김.
                                   alert(e?.message || "AI 이미지 생성에 실패했습니다. 잠시 후 다시 시도해 주세요.");
                                   setDisabledBtn(false)
                               })
                           }}
            >
                <div>
                    <div>AI 요청사항을 적으세요</div>
                    <TextInput />
                </div>
            </SuspensePopup>
        </>
    )
}

export default ImageForm